__turbopack_context__.v({
  "badge": "CeoSection-module__ZZr9nW__badge",
  "bsz": "CeoSection-module__ZZr9nW__bsz",
  "ceo__section": "CeoSection-module__ZZr9nW__ceo__section",
  "image__wrap": "CeoSection-module__ZZr9nW__image__wrap",
  "left": "CeoSection-module__ZZr9nW__left",
  "right": "CeoSection-module__ZZr9nW__right",
  "sizer": "CeoSection-module__ZZr9nW__sizer",
});
